import * as React from 'react';
import styled from "styled-components";
import themes from "@/styles/themes";
import Nullable from '@/types/utils/Nullable';
import { IParcelamentoOptions } from '@/store/slices/offerSlice';

interface ISelectProps {
  errorMessage?: Nullable<string>;
  className?: string;
  name?: string;
  id?: string;
  placeholder?: string;
  type?: string;
  value?:string;
  onChange: (event: any) => void;
  OnClick: (event: any) => void;
  options: (undefined |string | IParcelamentoOptions)[];
  disabled?: boolean;
}

const FormGroup = styled.div`
  position: relative;
  margin: 8px 0 0 0;

  &.group-invalid select {
    border: 1px solid ${themes.red} !important;
    color: ${themes.red}
  }

  &.group-valid select {
    border: 1px solid ${themes.green};
    box-shadow: 0 0 5px ${themes.green};
  }

  span.error {
    color: ${themes.redDark};
    font-size: 12px;
    margin-top: 5px;
    display: block;
  }
`;

const SelectStyle = styled.select`
  border: 1px solid ${themes.estadao};
  color: ${themes.estadao};
  border-radius: 5px;
  outline: none;
  width: 100%;
  font-size: 16px;
  height: 50px;
  padding-left: 14px;
  transition: all .3s ease-out;
  appearance: none;
  background-image: url('/imgs/wf-arrow-l.png');
  background-position: right 14px center;
  background-repeat: no-repeat;

  &:focus {
    box-shadow: 0 0 0 2px rgba(37, 117, 232, .3);
  }
  &:disabled {
    color:#000000;
    background: transparent;
  }
`;  

const OptionStyle = styled.option`
  font-size: 16px;
  color: ${themes.estadao};
`;

const LabelAlert = styled.label`
  position: absolute;
  top: 15px;
  right: 15px;
  background: #fff;
  color: ${themes.red};
  display: flex;
  align-items: center;
`;

const Select = (props: ISelectProps) => {
  const {
    errorMessage,
    className,
    name,
    id,
    value,
    placeholder,
    onChange,
    OnClick,
    options,
    disabled
  } = props;

  const flatOptions = Array.isArray(options[0]) ? options.flat() : options;

  const normalizedOptions: (IParcelamentoOptions | undefined)[] = flatOptions.map(opt =>
    typeof opt === 'string'
      ? { value: opt, texto: opt }
      : {
          value: opt?.value,
          texto: opt?.texto ?? opt?.text
        }
  );

  const groupClass =
    errorMessage == null
      ? ''
      : errorMessage === ''
        ? 'group-valid'
        : 'group-invalid';

  return (
    <FormGroup className={groupClass}>
      <SelectStyle
        name={name}
        id={id}
        value={value}
        className={className}
        onChange={onChange}
        onClick={OnClick}
        disabled={disabled}
      >
        {normalizedOptions.map((option) => (
          <OptionStyle key={option?.value} value={option?.value}>
            {option?.texto}
          </OptionStyle>
        ))}
      </SelectStyle>

      {errorMessage && (
        <>
          <span className="error">{errorMessage.replace(new RegExp(name ?? '', 'g'), placeholder ?? '')}</span>
        </>
      )}
    </FormGroup>
  );
};

export default Select;
